// <div data-controller="karrot-audits--index">
//
// </div>
import {Controller} from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
    static targets = [
        "auditLogsContainer",
        "resourceAttributesContainer"
    ];
    static classes = [""]
    static values = {
        lastSortKey: String,
        params: Object,
        loading: Boolean,
        finished: Boolean,
    };

    initialize() {

    }

    loadMore = () => {
        this.loadingValue = true;
        if (this.lastSortKeyValue) {
            api.get("/admin/audits", {
                last_sort_key: this.lastSortKeyValue,
                ...this.paramsValue
            }, {}).then((res) => {
                const responseDoc = new DOMParser().parseFromString(res.data, "text/html");
                const loadAuditLogs = responseDoc.getElementById("loadAuditLogs")
                const loadMoreAttributes = responseDoc.getElementById("loadMoreAttributes")

                const auditLogs = loadAuditLogs.innerHTML;
                const nextSortKey = loadAuditLogs.dataset.nextSortKey

                this.auditLogsContainerTarget.insertAdjacentHTML('beforeend', auditLogs);

                if (this.hasResourceAttributesContainerTarget) {
                    const newAttributes = Object.assign(JSON.parse(this.resourceAttributesContainerTarget.innerHTML), JSON.parse(loadMoreAttributes.innerHTML))
                    this.resourceAttributesContainerTarget.innerHTML = JSON.stringify(newAttributes, null, 2);
                }

                if (nextSortKey.trim() === "") {
                    this.finishedValue = true;
                    this.loadingValue = false;
                } else {
                    this.lastSortKeyValue = nextSortKey;
                    this.loadingValue = false;
                    this.onScroll(null);
                }
            })
        }
    }

    onScroll(e) {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 2000) {
            if (!this.loadingValue && !this.finishedValue) {
                this.loadMore();
            }
        }
    }

    connect() {
        this.loadMore();
    }

    disconnect() {

    }
}
